/* eslint-disable */
import { observable, action, computed } from 'mobx';
import groupInfoStore from './groupInfoStore';
import * as TextService from 'services/TextService';
import * as HomeService from 'services/HomeService';
import { hashHistory } from 'react-router';
window.hashHistory = hashHistory;
import { toast } from 'utils/notification';
import { transformNumber, transformString } from 'utils/transformType';
const { Time, Verify, Account, Dashi, Group, URL } = window.$ACE;
const templateId = 12;

/**
 * 基本信息Store
 */
class DashboardStore {
  @observable
  isLogin = false; // 是否登录
  @observable
  isNewUser = false; // 是否为新用户
  @observable
  channel = 'N'; // 分享渠道
  @observable
  shareType = 'N'; // 分享类型
  @observable
  userCode = ''; // 当前登录用户的云大使Code
  @observable
  groupCode = null; // 当前登录用户的参加的团或者开的团Code
  @observable
  shareUserCode = ''; // 当前URL里的用户Code，如果没有则为空
  @observable
  shareGroupCode = ''; // 当前URL里的团Code，如果没有则为空
  @observable
  groupMembers = []; // 团成员
  @observable
  pcActivityRule = null; //PC活动规则

  @observable
  yundashiRule = null; // 云大使协议
  // 云大使分享模块
  // @observable
  // canApplyAmbassador = {}; // 如果不是云大使，判断是否可以成为云大使

  @observable
  loading = true; // 初始化状态

  @observable
  homeData12 = {
    pcData: {
      topText: '',
      bannerText: '',
      strategy: '',
      selfInfo: '',
      newBuyDesc: '',
      oldUserOpenTeam: {
        oneContent: '',
        twoContent: '',
        threeContent: '',
        fourContent: '',
      },
    },
    h5Data: {
      topText: '',
    },
  }; // 初始化首页文案

  // 分享URL的生成规则：分享类型.当前用户团队Code.当前用户云大使Code（可选）
  @computed
  get shareUrl() {
    const url = `${location.origin}${location.pathname}?params=${this.shareType}.${this.groupCode}`;
    return url;
  }

  @computed
  get isShare() {
    const { URL } = window.$ACE;
    return URL.getSearch().params;
  }

  // 当前用户是否开团
  @computed
  get isCreateTeam() {
    return this.groupCode != null;
  }

  // @observable
  // checkAmbassador = 0; // 云大使状态标记
  // 已经是云大使
  @computed
  get hasApplied() {
    return this.userCode != '';
  }
  init = async () => {
    await this.queryBaseData();
    this.fetchHomeText12();
    this.loading = false;
    // 初始化分享
    const { shareText } = this.homeData12.pcData;
    const share = window.$ACE.Share.create({
      title: shareText.title,
      content: shareText.content,
      img: shareText.img,
    });
    share.wxShare();
  };
  queryBaseData = async () => {
    this.parseUrl();
    // toast({ type: 'remind' });
    // 登录判断
    const isLogin = await Account.isLogin();
    this.isLogin = isLogin;
    if (!isLogin) {
      // 未登录状态
      // console.log('未登录状态');
      // 分享页
      if (this.isShare) {
        // console.log('分享页，获取分享者信息');
        await groupInfoStore.fetchGroupInfo(this.shareGroupCode);
      }
    } else {
      // console.log('已登录状态');
      // 已登录状态
      // 获取当前用户是否为新用户
      this.isNewUser = await Verify.query('act1153430572');
      // console.log('当前用户身份', this.isNewUser ? 'new' : 'old');
      // 去掉新用户的限制
      // if (!this.isNewUser) {
      // console.log('老用户-获取其开团信息');
      await groupInfoStore.getGroupInfo();
      // }
      // 分享页
      if (this.isShare) {
        // console.log('是分享页');
        if (this.isNewUser) {
          // console.log('新用户-获取当前分享的团信息');
          await groupInfoStore.fetchGroupInfo(this.shareGroupCode);
        } else {
          // console.log('老用户-重定向');
          // 进入分享页，但用户已有团的情况下，直接重定向到用户的团页面下
          location.href = `${location.origin}${location.pathname}`;
        }
        return;
      }
      // 获取当前登录用户的云大使基本信息
      const info = await Dashi.info();
      // console.log('该用户云大使基本信息', info);
      if (info) {
        this.userCode = info.userCode;
      }
      if (!this.userCode) {
        // this.canApplyAmbassador = { status, errorCode, msg } = await Dashi.verify();
        // await this.fetchyundashiRule()
      }
    }
  };
  // 解析URL里的分享类型，分享团Code，分享者Code
  parseUrl = async () => {
    const { URL, Client, Group, Dashi } = window.$ACE;
    const params = URL.getSearch().params;
    // 获取分享渠道
    this.channel = Client.getChannel();
    if (params) {
      const [shareType, shareGroupCode] = params.split('.');
      this.shareType = shareType;
      this.shareGroupCode = shareGroupCode;
      // 根据groupCode获取团Code
      const groupInfo = await Group.getGroupDetail(shareGroupCode);
      this.shareUserCode = groupInfo.userCode;
      // 访问即关联
      Dashi.bind(this.shareUserCode);
    }
  };
  //查询PC活动规则
  @action
  fetchPCActivityRule = async () => {
    try {
      const data = await HomeService.fetchPCActivityRule12();
      if (data) {
        this.pcActivityRule = data;
      }
    } catch (e) {
      console.log(e);
    }
  };
  //查询首页文案
  fetchHomeText12 = async () => {
    try {
      const data = await TextService.fetchHomeText12();
      if (data) {
        this.homeData12 = data;
      }
    } catch (e) {
      console.log(e);
    }
  };

  // 查询云大使协议
  // @action
  // fetchyundashiRule = async () => {
  //   await TextService.fetchyundashiRule().then(results => {
  //     this.yundashiRule = results;
  //     console.log(results, "rrr")
  //   })
  // };
}
let dashboardStore = new DashboardStore();
export default dashboardStore;



// WEBPACK FOOTER //
// ./src/scripts/stores/1212Store.js